module.exports = __webpack_public_path__ + "static/media/step-cadastro.02d6eb54.svg";